import * as Actions from 'FormsUI/actions/RedirectUrls';
const INIT_STATE = {
  externalUrls: []
};
export function redirectUrls(state = INIT_STATE, action) {
  switch (action.type) {
    case Actions.ADD_EXTERNAL_URL:
      return Object.assign({}, state, {
        externalUrls: state.externalUrls.concat([action.url])
      });
    default:
      return state;
  }
}